import MobileMenu from "./js/MobileMenu"
import Search from "./js/Search"
import HeroSlider from "./js/heroSlider"
const mobileMenu = new MobileMenu()
const search = new Search()
const heroSlider = new HeroSlider()
